import { FC, ReactNode } from 'react';
import cn from 'classnames';
import { ReactComponent as StarActiveIcon } from 'images/newIcons/starActive.svg';
import { ReactComponent as StarPassiveIcon } from 'images/newIcons/starPassive.svg';

import { TextTooltip } from 'components/ui/TextTooltip';

interface QuickEntityTileProps {
  id: string;
  title: string;
  icon: ReactNode;
  isFavorite: boolean;
  isActive?: boolean;
  onClick: (id: string, isActive?: boolean) => void;
  onFavoriteToggle: (id: string, isFavorite: boolean) => void;
}

export const QuickEntityTile: FC<QuickEntityTileProps> = ({
  id,
  title,
  icon,
  isFavorite,
  isActive,
  onClick,
  onFavoriteToggle,
  ...props
}) => (
  <div
    role="button"
    className={cn(
      'relative flex justify-center items-center aspect-square rounded-[2px] bg-light cursor-pointer hover:bg-dark',
      isActive && 'outline outline-2 outline-bright_product'
    )}
    onClick={() => onClick(id, isActive)}
    {...props}
  >
    <div
      className="absolute top-1 right-1 [&>svg]:hover:!text-dark_product"
      onClick={(e) => {
        e.stopPropagation();
        onFavoriteToggle(id, !isFavorite);
      }}
    >
      {isFavorite ? (
        <StarActiveIcon className="text-bright_product" />
      ) : (
        <StarPassiveIcon className="text-tpg_light" />
      )}
    </div>
    <div className="flex flex-col justify-center items-center w-full h-full p-1 gap-2">
      <div className="flex flex-col justify-end items-center w-full h-full">
        {icon}
      </div>
      <div className="w-full h-full">
        <TextTooltip
          value={title}
          classNames={{
            childrenClassName:
              'relative !line-clamp-2 !whitespace-normal text-center tpg-c2 text-tpg_title',
          }}
        />
      </div>
    </div>
  </div>
);
